"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeDate = exports.DateSelect = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const elements_1 = require("@src/components/elements");
const { RangePicker } = elements_1.DatePicker;
exports.DateSelect = (0, styled_components_1.default)(elements_1.DatePicker) `
	width: 100%;
`;
exports.RangeDate = (0, styled_components_1.default)(RangePicker) `
	width: 100%;
`;
